import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';
import { BusinessSwitchState } from './business-switch-state';

/**
 * Forces route re-creation across a business switch.
 *
 * Angular's default strategy reuses a route when navigating to the same config
 * (the common "switch while on the projects list" case), so the destination
 * component would not re-initialize and would not refetch for the new business.
 * While a switch is mid-flight we decline reuse; otherwise we defer to the
 * framework default. Paired with `onSameUrlNavigation: 'reload'` in the router
 * config so same-URL switches actually re-run.
 */
@Injectable({ providedIn: 'root' })
export class BusinessSwitchRouteReuseStrategy extends BaseRouteReuseStrategy {
	constructor(private readonly switchState: BusinessSwitchState) {
		super();
	}

	public override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
		if (this.switchState.switching) {
			return false;
		}
		return super.shouldReuseRoute(future, curr);
	}
}
